import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './GoblinsAbilitiesToolbar.css';
import {
  GOBLINS_ABILITY_MODES,
  GOBLINS_ABILITY_RADIUS,
  GOBLINS_TRAP_SETUP_COST
} from "../../../../../configs/factions/goblins";
import {setGoblinsAbilityMode, showToast} from "../../../../../redux/actions";
import {selectGoblinsAbilityMode} from "../../../../../redux/reducers/privateStateReducer/selectors";
import {selectCurrentPlayer} from "../../../../../redux/reducers/sharedStateReducer/selectors";
import {HexButtonFrame} from "../../../../gameUi/HexButton";
import {joinClassNames} from "../../../../gameUi/joinClassNames";
import {getPlayerColorStyle} from "../../../../../utils/gameUi/getPlayerColorStyle";
import {getTokenRowSlots, TokenGlint, TokenPrice, TokenSpotlight} from "../../../TokenMuster/TokenMuster";

const MODE_TOKENS = [
  {id: GOBLINS_ABILITY_MODES.SET_TRAP, name: 'Установить ловушку', icon: '/img/icons/trap_white.png', price: GOBLINS_TRAP_SETUP_COST},
  {id: GOBLINS_ABILITY_MODES.REMOVE_TRAP, name: 'Снять ловушку', icon: '/img/icons/trap_white.png', isRemoval: true},
  {id: GOBLINS_ABILITY_MODES.DAMAGE_BUILDING, name: 'Повредить строение', icon: '/img/icons/building_damage.png'},
];
const MODE_SLOTS = getTokenRowSlots(MODE_TOKENS);
const TEXT_CHOOSE_MODE = 'Выберите способность';

// Три взаимоисключающих режима цели (см. add-goblins-faction design.md
// Decision 3) - выбор режима переключает, какая из трёх
// calculateAvailable*Cells используется для подсветки поля и обработки
// клика в GameScene.handleAbilitiesPhaseClick. Сам бросок/попытка происходит
// кликом по гексу-цели на поле, а не кнопкой тулбара - по образцу
// SuccubesAbilitiesToolbar. Режимы — рядом жетонов, как в панелях найма и
// строительства (TokenMuster), подпись — под каждым: подсказка занята целью режима
const GoblinsAbilitiesToolbar = () => {
  const dispatch = useDispatch();
  const mode = useSelector(selectGoblinsAbilityMode);
  const currentPlayer = useSelector(selectCurrentPlayer);

  const canAffordTrapSetup = currentPlayer.coins >= GOBLINS_TRAP_SETUP_COST;

  const setMode = (nextMode) => {
    const isActivating = mode !== nextMode;
    // Установку ловушки нельзя даже НАЧАТЬ выбирать без достаточного числа
    // монет (стоимость попытки списывается независимо от исхода, см.
    // GOBLINS_TRAP_SETUP_COST) - иначе игрок выбирает режим, подсвечивает
    // гекс-цель, кликает по нему, и лишь тогда узнаёт из тоста reducer'а
    // (`console.warn`, никак не показывается игроку), что попытка тихо
    // ничего не сделала
    if (isActivating && nextMode === GOBLINS_ABILITY_MODES.SET_TRAP && !canAffordTrapSetup) {
      dispatch(showToast('Недостаточно монет для установки ловушки.', 'warning', 3000));
      return;
    }
    dispatch(setGoblinsAbilityMode(isActivating ? nextMode : null));
  };

  const hints = {
    [GOBLINS_ABILITY_MODES.SET_TRAP]: `Выберите гекс в радиусе ${GOBLINS_ABILITY_RADIUS} для установки ловушки`,
    [GOBLINS_ABILITY_MODES.REMOVE_TRAP]: `Выберите свою ловушку в радиусе ${GOBLINS_ABILITY_RADIUS} для снятия`,
    [GOBLINS_ABILITY_MODES.DAMAGE_BUILDING]: `Выберите вражеское строение в радиусе ${GOBLINS_ABILITY_RADIUS}`,
  };

  return (
    <div className={'goblins-abilities-toolbar'} style={getPlayerColorStyle(currentPlayer.color)}>
      <div key={mode || 'none'} className={'goblins-abilities-toolbar_hint'}>{hints[mode] || TEXT_CHOOSE_MODE}</div>

      <div className={'goblins-abilities-toolbar_modes token-muster'} style={{'--token-count': MODE_TOKENS.length, '--token-groups': 0}}>
        <TokenSpotlight spot={MODE_SLOTS[mode]}/>
        {MODE_TOKENS.map(({id, name, icon, price, isRemoval}, index) => (
          <div
            key={id}
            className={joinClassNames(
              'token-muster_item',
              id === GOBLINS_ABILITY_MODES.SET_TRAP && !canAffordTrapSetup && 'token-muster_item_unaffordable',
            )}
            style={{'--slot-index': index}}
          >
            <button
              className={joinClassNames('gui-hex-button', 'gui-hex-button_stone', 'toolbar-button', mode === id && 'gui-hex-button_selected')}
              aria-pressed={mode === id}
              title={name}
              onClick={() => setMode(id)}
            >
              <span className={'goblins-abilities-toolbar_mode-icon'}>
                <img src={icon} alt={''}/>
                {isRemoval && <span className={'goblins-abilities-toolbar_mode-cross'} aria-hidden={true}/>}
              </span>
              {mode === id ? <HexButtonFrame className={'cell-icon'}/> : null}
              <TokenGlint/>
              {price !== undefined && <TokenPrice price={price}/>}
            </button>
            <div className={'goblins-abilities-toolbar_mode-name'}>{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoblinsAbilitiesToolbar;
